import React, { useState } from "react";
import {
  ButtonBase,
  Collapse,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { Bookmark, ExpandLess, ExpandMore } from "@material-ui/icons";
import { format, parseISO } from "date-fns";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  root: {
    flex: "none",
    borderRadius: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.type === "dark" ? "#1f2937" : "#fff8dc",
    zIndex: 2,
  },
  summary: {
    width: "100%",
    padding: theme.spacing(1, 2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.type === "dark" ? "#fbbf24" : "#8a5a00",
  },
  count: {
    marginLeft: "auto",
    fontWeight: 700,
  },
  list: {
    maxHeight: 190,
    overflowY: "auto",
    padding: theme.spacing(0, 2, 1),
  },
  item: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    borderLeft: "3px solid #f59e0b",
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
  },
  meta: {
    display: "block",
    marginTop: 3,
    opacity: 0.7,
  },
}));

const describeMessage = message => {
  if (message.mediaType === "image") return i18n.t("pinnedMessages.image");
  if (message.mediaType === "audio") return i18n.t("pinnedMessages.audio");
  if (message.mediaType === "video") return i18n.t("pinnedMessages.video");
  if (message.mediaType === "location") return i18n.t("pinnedMessages.location");
  if (message.mediaType === "vcard") return i18n.t("pinnedMessages.contact");
  return message.body || i18n.t("pinnedMessages.message");
};

const PinnedMessagesBar = ({ messages }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  if (!messages.length) return null;

  return (
    <Paper square elevation={1} className={classes.root}>
      <ButtonBase className={classes.summary} onClick={() => setOpen(value => !value)}>
        <Bookmark fontSize="small" />
        <Typography variant="subtitle2">{i18n.t("pinnedMessages.title")}</Typography>
        <span className={classes.count}>{messages.length}</span>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ButtonBase>
      <Collapse in={open}>
        <div className={classes.list}>
          {messages.map(message => (
            <div className={classes.item} key={message.id}>
              <Typography variant="body2" noWrap>
                {describeMessage(message)}
              </Typography>
              <Typography variant="caption" className={classes.meta}>
                {message.contact?.name || i18n.t("pinnedMessages.you")}
                {message.pinnedUntil
                  ? ` · ${i18n.t("pinnedMessages.until")} ${format(parseISO(message.pinnedUntil), "dd/MM/yyyy HH:mm")}`
                  : ""}
              </Typography>
              <Typography
                variant="caption"
                style={{ color: message.pinSynced ? "#16a34a" : "#f59e0b", fontWeight: 600 }}
              >
                {i18n.t(message.pinSynced ? "pinnedMessages.synced" : "pinnedMessages.localOnly")}
              </Typography>
            </div>
          ))}
        </div>
      </Collapse>
    </Paper>
  );
};

export default PinnedMessagesBar;
